export const NBSP = '\u00A0';
export const PERCENTAGE = '%';
